// Danh sách email BGĐ (whitelist).
// So sánh theo lowercase + trim.
export const BGD_EMAILS = new Set([
]);

export function isBGDEmail(email) {
  if (!email) return false;
  const normalized = String(email).trim().toLowerCase();
  return BGD_EMAILS.has(normalized);
}
